export default __webpack_public_path__ + "opco2i.a2da37d.png";